import { render, staticRenderFns } from "./ModalAddCategories.vue?vue&type=template&id=d7576dc0&scoped=true&"
import script from "./ModalAddCategories.vue?vue&type=script&lang=js&"
export * from "./ModalAddCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7576dc0",
  null
  
)

export default component.exports